<template>
	<div class="w1200 flex flex-direction align-stretch benben-flex-layout bind">
	    <div class="flex bind_1">
	    	<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
	    		<img class="bind_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
	    		<div class="bind_1_2">{{$t('返回')}}</div>
	    	</div>
	    </div>
		<div class="topUpList_1">{{$t('充值订单')}}</div>
		<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
			<div v-if="chong_list.length > 0">
				<template v-for="(item,index) in chong_list">
					<div class="flex meaList_2">
						<div class="flex-sub meaList_3">
							<div class="meaList_4">{{item.remark}}</div>
							<div class="meaList_5">{{item.create_time}}</div>
						</div>
						<div class="flex flex-direction flex-wrap align-end benben-flex-layout">
							<div class="meaList_6">${{item.order_money}}</div>
							
							<div class="flex meaList_7">
								<div class="meaList_8" v-if=" item.type=='1'">{{$t('手动充值')}}</div>
								<div class="meaList_8" v-else>{{$t('自动划扣')}}</div>
							</div>
						</div>
					</div>
				</template>
			</div>
			<div v-else style="text-align: center;padding: 40px 0;">
				<img style="width: 217px;height: 177px;" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
			</div>
			<div v-if="chong_list.length > 0" style="text-align: center;margin: 20px  0;">
				<el-pagination
				   @current-change="handleCurrentChange"
				   layout="prev, pager, next"
				   :current-page.sync="page" :page-size="page_size"
				   :total="total">
				 </el-pagination>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				chong_list:'',
				total:0,
				page:1,
				page_size:10,
				loading:true,
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post68d508a33bd92()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
			
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68d508a33bd92()
			},
			// 切换页面
			handleCurrentChange(val){
				this.page = val
				this.post68d508a33bd92()
			},
			//获取饭票明细记录
			post68d508a33bd92(){
				this.$api.post(this.$apiUrls.post68d508a33bd92,{page:this.page,list_rows:this.page_size}).then((res) => {
					if(res.code == 1){
						this.chong_list = res.data.data
						this.total = res.data.total
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type){
				if(type == 1){
					window.history.back();
					return
				}else if(type == 2){
					this.$router.push({
						name: 'myinfo',
					});
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.bind{
		margin-top: 20px;
		padding: 0 20px 100px;
		background: #fff;
	}
	.bind_1{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.bind_1_1{
		width: 14px;
		height: 14px;
	}
	.bind_1_2{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 10px;
	}
	.topUpList_1{
		font-weight: 500;
		font-size: 16px;
		color: #1A1A1A;
		margin: 16px 0 0 0;
	}
	.meaList_2{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.meaList_3{
		margin: 0 32px 0 0;
	}
	.meaList_4{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.meaList_5{
		font-weight: 400;
		font-size: 14px;
		color: #999999;
		margin: 10px 0 0 0;
	}
	.meaList_6{
		font-weight: 500;
		font-size: 16px;
		color: #1A1A1A;
	}
	.meaList_7{
		margin-top: 10px;
	}
	.meaList_8{
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #999999;
		font-weight: 400;
		font-size: 12px;
		color: #999999;
		padding: 0 10px;
		margin: 0 0 0 16px;
	}
</style>